// extracted by mini-css-extract-plugin
export var placesMoreButton = "AKCB4";
export var placesMoreButtonMargin = "gWN1L";